import { DifferencesForm } from "app/component/form/data_entry/differences/DifferencesForm";

export const DifferencesPage = DifferencesForm;
